import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faSearch } from "@fortawesome/free-solid-svg-icons";
import apiServices from "../../../../services/apiService";
import ComonTable from "../../../common/table/ComonTable";

const ParkingSlotList = () => {
    const [slots, setSlots] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const navigate = useNavigate();

    const columns = [
        { key: "Id", label: "Slot ID" },
        { key: "SlotName", label: "Slot Name" },
        { key: "SiteName", label: "Site" },
        { key: "WingName", label: "Wing" },
        { key: "FloorName", label: "Floor" },
        { key: "VehicleTypeName", label: "Vehicle Type" },
        { key: "ParkingTypeName", label: "Parking Type" }
    ];

    const fetchSlots = async () => {
        setLoading(true);
        try {
            const res = await apiServices({
                url: `/ParkingSlotMaster/getallParkingSlotId`,
                method: 'GET'
            });

            if (res.success && res.data?.isSuccess) {
                const mapped = res.data.data.map(s => ({
                    Id: s.Id,
                    SlotName: s.SlotName,
                    SiteName: s.SiteName,
                    WingName: s.WingName,
                    FloorName: s.FloorName,
                    VehicleTypeName: s.VehicleTypeName,
                    ParkingTypeName: s.ParkingTypeName
                }));
                // Descending sort
                mapped.sort((a, b) => b.Id - a.Id);
                setSlots(mapped);
            } else {
                setSlots([]);
            }
        } catch (error) {
            console.error("Error fetching slots:", error);
            toast.error("Failed to fetch parking slots");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSlots();
    }, []);

    const filteredSlots = slots.filter(slot =>
        slot.SlotName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        slot.SiteName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        slot.WingName?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="p-6">
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-2xl font-bold text-gray-800">Parking Slots</h1>
                <button
                    onClick={() => navigate('/zentres/parking-management/parking-slot/add')}
                    className="bg-[#E31F26] text-white px-4 py-2 rounded-lg flex items-center gap-2 hover:bg-[#c11a20] transition-colors"
                >
                    <FontAwesomeIcon icon={faPlus} />
                    <span>Add Parking Slot</span>
                </button>
            </div>

            <div className="bg-white rounded-xl shadow-sm p-4 border border-gray-100">
                <div className="mb-4 relative w-72">
                    <input
                        type="text"
                        placeholder="Search parking slots..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="w-full pl-10 pr-4 py-2 border rounded-lg outline-none focus:border-red-500 transition-colors"
                    />
                    <FontAwesomeIcon icon={faSearch} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                </div>
                
                <ComonTable
                    columns={columns}
                    data={filteredSlots}
                    loading={loading}
                />
            </div>
        </div>
    );
};

export default ParkingSlotList;
